// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import SettingOutlinedSvg from "@fishx/icons-svg/es/asn/SettingOutlined";
import FishxIcon from '../components/FishxIcon';

var SettingOutlined = function SettingOutlined(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: SettingOutlinedSvg
  }));
};

SettingOutlined.displayName = 'SettingOutlined';
export default React.forwardRef(SettingOutlined);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/SettingOutlined.js
// module id = 4085
// module chunks = 0